"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewThirdPartyIntegration extends new_item_1.default {
    constructor(newThirdPartyIntegration) {
        super();
        this.integrationMetaData = newThirdPartyIntegration.integrationMetaData;
    }
}
exports.default = NewThirdPartyIntegration;
//# sourceMappingURL=new-thirdPartyIntegration.js.map